const RatingReview = () =>
    import ( /* webpackChunkName: "DoctorProfile" */ "@/components/profile/RatingReview");
const DoctorTimeFee = () =>
    import ( /* webpackChunkName: "DoctorProfile" */ "@/components/profile/doctor/TimeFees");
const DoctorAbout = () =>
    import ( /* webpackChunkName: "DoctorProfile" */ "@/components/profile/doctor/About");

export default [{
        path: "",
        redirect: {
            name: "profile.doctor.time-fees"
        }
    },
    {
        path: "time-fees",
        name: "profile.doctor.time-fees",
        component: DoctorTimeFee
    },
    {
        path: "rating-review",
        name: "profile.doctor.rating",
        component: RatingReview
    },
    {
        path: "about",
        name: "profile.doctor.about",
        component: DoctorAbout
    }
];